<template>
  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
    <md-card>
      <md-card-header  data-background-color="newyellow">
       
         <div style="display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;">
          <h4 class="tittle">Registros de Logs Gerais</h4>
          <v-btn
          v-if="logs.length > 0"
            color="#88C658"
            class="ma-2 white--text"
            small
            fab
            v-clipboard="logs"
            @click="msg = 'Copiado com sucesso.'"
          >
            <font-awesome-icon icon="copy" />
          </v-btn>
        </div>
      </md-card-header>
    
      <md-card-content>
        <div
          v-if="logs.length > 0"
          style="
        padding: 30px;
    color: rgb(51, 51, 51);
    max-height: 1200px;
    overflow-y: auto;overflow-x: hidden; font-family: 'Lucida Console'!important; font-size: 12px;"
        >
          <div v-for="(l,i) in logs" :key="i">
            <b style="font-weight: 900;">{{l.data | formatDateNormal}}</b>
            :
            {{l.dados}}
            <br />
          </div>
        </div>
        <div v-else>
          <b style="font-weight: 900;margin: 20px;padding:10px">Aguardando por logs...</b>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import * as Logs from "../../providers/logs.service";
export default {
  sockets: {
    connect() {
      console.log("socket connected");
    },
    logsEMS(data) {
      var self = this;

      var exists = false;

      self.type_arr.forEach(element => {
        var rgx = self.decode(element.REGEX);
        var re = new RegExp(rgx, "im");
        var nItem = data.match(re);

        if (nItem) {
          exists = true;
        }
      });

      if (!exists) {
        
        self.logs.unshift({ data: new Date(), dados: data });
      }
    }
  },
  created() {
    Logs.getLogsTypes().then(r => {
      this.type_arr = r;
    });
  },

  methods: {
    encode: function(s) {
      for (
        var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode;
        ++i < l;
        s[i] =
          (c = s[i].charCodeAt(0)) >= 127
            ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f))
            : s[i]
      );
      return s.join("");
    },
    decode: function(s) {
      for (
        var a,
          b,
          i = -1,
          l = (s = s.split("")).length,
          o = String.fromCharCode,
          c = "charCodeAt";
        ++i < l;
        (a = s[i][c](0)) & 0x80 &&
        ((s[i] =
          (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80
            ? o(((a & 0x03) << 6) + (b & 0x3f))
            : o(128)),
        (s[++i] = ""))
      );
      return s.join("");
    }
  },
  data() {
    return {
      type_arr: Array(),
      CMVVENDARAPIDA_ARRAY: Array(),
      logs: Array()
    };
  }
};
</script>
<style>
.configicon {
}
</style>